import React from "react";
import {useAppDispatch} from "../../../../../app/hooks";
import {ValidatedChipInputField} from "../../../../elements/validator/component/ValidatedChipInputField";
import {ValidatedSelectField} from "../../../../elements/validator/component/ValidatedSelectField";
import {FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import {MultipleEmailNotEmptyValidator, NotEmptyValidator} from "../../../../elements/validator/Validator";
import styles from "./TranscriptRoutingTab.module.css";
import {
    removeRoutingLocationDepartment,
    RoutingDepartment,
    selectRoutingLocationDepartmentName,
    selectRoutingLocationDepartmentRecipients,
    TranscriptRoutingSettingsUI,
    updateRoutingLocationDepartment
} from "./transcriptRoutingSlice";
import {fromChipValue, toChipValue} from "./transcriptRoutingUtils";

interface TranscriptRoutingDepartmentMappingRowProps {
    departments: RoutingDepartment[];
    locationIndex: number;
    departmentIndex: number;
    formContext: FormContext<TranscriptRoutingSettingsUI>;
}

export const TranscriptRoutingDepartmentMappingRow: React.FC<TranscriptRoutingDepartmentMappingRowProps> = ({
    departments,
    locationIndex,
    departmentIndex,
    formContext
}) => {
    const dispatch = useAppDispatch();
    const {updateValidationStatus, getMessage} = formContext;
    const getMessageWrapper = (field: string) => getMessage(field) || "";

    return <div className={styles.mappingRow}>
        <ValidatedSelectField<string, TranscriptRoutingSettingsUI>
            validator={NotEmptyValidator}
            selector={selectRoutingLocationDepartmentName(locationIndex, departmentIndex)}
            fieldName={`locations.${locationIndex}.departments.${departmentIndex}.departmentName`}
            onChange={departmentName => {
                const selected = departments.find(department => department.name === departmentName);
                dispatch(updateRoutingLocationDepartment({
                    locationIndex,
                    departmentIndex,
                    patch: {departmentId: selected?.id, departmentName}
                }));
            }}
            updateValidationStatus={updateValidationStatus}
            label="Department"
            options={departments.map(department => ({label: department.name, value: department.name}))}
            getMessage={getMessageWrapper}
            selectFirstOptionByDefault={false}
        />
        <ValidatedChipInputField<TranscriptRoutingSettingsUI>
            validator={MultipleEmailNotEmptyValidator}
            selector={state => toChipValue(selectRoutingLocationDepartmentRecipients(locationIndex, departmentIndex)(state))}
            fieldName={`locations.${locationIndex}.departments.${departmentIndex}.emailAddresses` as keyof TranscriptRoutingSettingsUI}
            onChange={value => dispatch(updateRoutingLocationDepartment({
                locationIndex,
                departmentIndex,
                patch: {emailAddresses: fromChipValue(value)}
            }))}
            updateValidationStatus={updateValidationStatus}
            label="Routing recipients"
            placeholder="example@mail.com"
            getMessage={getMessageWrapper}
        />
        <button
            type="button"
            className={styles.iconActionButton}
            aria-label="Remove department recipients"
            onClick={() => dispatch(removeRoutingLocationDepartment({locationIndex, departmentIndex}))}
        >
            <img src="/deleteIcon.svg" alt=""/>
        </button>
    </div>;
};
